module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-petit-gift-2f93e085c6b1a3005c2a399aac912282.png";